import { Component, Input, OnInit } from "@angular/core";
import { HttpService } from "app/service/http/http.service";
import { MemberService } from "app/service/member/member.service";

@Component({
  selector: "modal-leave",
  templateUrl: "./modal-leave.component.html",
  styleUrls: ["../modal.component.scss", "./modal-leave.component.scss"],
})
export class ModalLeaveComponent implements OnInit {
  constructor(
    private httpService: HttpService,
    private memberService: MemberService
  ) {}

  ngOnInit() {
    if (this.isVisible) {
      document.body.style.overflow = "hidden";
    }
  }

  async handleSubmit() {
    await this.memberService.leave();
    alert("헤이그라운드 홈페이지 탈퇴가 완료되었습니다");
    this.httpService.logout();

    document.body.style.overflow = "";
    location.href = "/";
  }

  handleCancel() {
    this.modal.show = false;
    document.body.style.overflow = "";
  }

  @Input()
  get modal() {
    return this._modal;
  }
  set modal(data) {
    this._modal = data;
  }
  private _modal = {
    show: false,
  };

  get isVisible() {
    return this.modal.show;
  }
}



// WEBPACK FOOTER //
// ./src/app/modal/leave/modal-leave.component.ts